import { render, staticRenderFns } from "./HeroSearch.vue?vue&type=template&id=6a00a55a&lang=html&"
import script from "./HeroSearch.vue?vue&type=script&lang=js&"
export * from "./HeroSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports